import { FormattedMessage } from 'react-intl'

import { useMeQuery } from '@/src/features/auth/services/useMeQuery'

import type { TMediumMessageApi } from '../../../api/types/messageApi.types'
import { MESSAGE_TYPE } from '../../../models/Message.enums'
import { chatMessageAutoData } from '../ChatMessage/ChatMessageAuto/chatMessageAutoData'

type TPreviewContentTextProps = {
  contactName: string
  message: TMediumMessageApi
}

export const PreviewContentText = ({ contactName, message }: TPreviewContentTextProps) => {
  const { data: me } = useMeQuery()
  const { payload, senderId, type } = message
  const isSender = me?.id === senderId

  switch (type) {
    case MESSAGE_TYPE.TEXT:
      return payload.text
    case MESSAGE_TYPE.REPLY_TO_UPLIFT_MESSAGE:
      return message.payload.uplift_text
    case MESSAGE_TYPE.PRAYER_ON_COMMENT:
    case MESSAGE_TYPE.PRAYER:
    case MESSAGE_TYPE.GODSON_JOINED:
    case MESSAGE_TYPE.THANKS_INTENTION_PRAYER:
    case MESSAGE_TYPE.THANKS_BIRTHDAY_INTENTION_PRAYER:
    case MESSAGE_TYPE.THANKS_ARRIVAL_INTENTION_PRAYER:
      return (
        <>
          {chatMessageAutoData[type].emoji}{' '}
          <FormattedMessage
            id={chatMessageAutoData[type].title[isSender ? 'fromMe' : 'toMe']}
            values={{ contactName }}
          />
        </>
      )
    default:
      return ''
  }
}
